module.exports = __webpack_public_path__ + "img/qr-code.e25f4b83.png";